import React from "react";
import { Dispatch } from "redux";

import { DynamoNode } from "dynamo-models";

import { Grid, Button } from "@material-ui/core";

import { INodeDropCollectedProps } from "..";

import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import DeleteIcon from "@material-ui/icons/Delete";
import UndoIcon from "@material-ui/icons/Undo";
import RedoIcon from "@material-ui/icons/Redo";
import { withDropGeneral, Orientation, FAIR_COLOR } from "./dragDropContainers";
import { connect } from "react-redux";
import { IEditorState, doUndo, doRedo, addPage, trashNode, trashSelectedNode } from "../../redux";

export interface IActionProps {
    canUndo: boolean;
    canRedo: boolean;
    allowNewPages: boolean;

    addPage: () => void;
    undo: () => void;
    redo: () => void;
    onTrash: (droppable: any, index: number) => void;
    onTrashSelected: () => void;
}

class EditorActions extends React.Component<IActionProps> {
    public render() {
        const {
            addPage,
            onTrash,
            undo,
            redo,

            canUndo,
            canRedo,
            allowNewPages
        } = this.props;

        const getDropStyle = (props: INodeDropCollectedProps) => ({
            height: "100%",
        });

        const getRender = (props: INodeDropCollectedProps) => {
            const deleteButtonStyle: React.CSSProperties = {
                borderRadius: 0, 
                borderTopRightRadius: 5, 
                borderBottomRightRadius: 5, 
                background: props.isOverShallow ? FAIR_COLOR : undefined,
                width: "100%", 
                height: "100%"
            }

            return (
                <Button color="secondary" size="small" variant="contained" style={deleteButtonStyle} onClick={this.props.onTrashSelected}>
                    <DeleteIcon />
                </Button>
            )
        }
        
        const deleteDropProps = ({
            getStyle: getDropStyle,
            orientation: Orientation.horizontal,
            onDrop: onTrash,
            getRender: getRender
        })

        return (
            <Grid container item key={0} direction="row" style={{width: "100%", gridRow: 0, padding: 10}} wrap="nowrap">
                <Grid key={0} sm item style={{borderTopLeftRadius: 5, borderBottomLeftRadius: 5}}>
                    <Button color="primary" size="small" variant="contained" style={{borderRadius: 0, borderTopLeftRadius: 5, borderBottomLeftRadius: 5, width: "100%"}} onClick={addPage} disabled={!allowNewPages}>
                        <InsertDriveFileIcon />
                    </Button>
                </Grid>
                <Grid key={1} sm item>
                    <Button color="primary" size="small" variant="contained" style={{borderRadius: 0, width: "100%"}} onClick={redo} disabled={!canRedo}>
                        <RedoIcon />
                    </Button>
                </Grid>
                <Grid key={2} sm item>
                    <Button color="secondary" size="small" variant="contained" style={{borderRadius: 0, width: "100%"}} onClick={undo} disabled={!canUndo}>
                        <UndoIcon />
                    </Button>
                </Grid>
                <Grid key={3} sm item>
                {
                    withDropGeneral(deleteDropProps)
                }
                </Grid>
            </Grid>
        );
    }
}

const stateToProps = (state: IEditorState) => ({
    canUndo: state.history.canStepBack(),
    canRedo: state.history.canStepForward()
})

const dispatchToProps = (dispatch) => ({
    addPage: () => dispatch(addPage()),
    undo: () => dispatch(doUndo()),
    redo: () => dispatch(doRedo()),
    onTrash: (droppable: any, index: number) => {
        const droppedNodeMaybe = droppable as DynamoNode | undefined;
        if (droppedNodeMaybe !== undefined) {
            dispatch(trashNode(droppedNodeMaybe));
            return { id: droppedNodeMaybe.nodeId }
        }
    },
    onTrashSelected: () => dispatch(trashSelectedNode()),
})

export const EditorActionsWidget = connect(stateToProps, dispatchToProps)(EditorActions);